// JUST FIREBASE LOGIC, HANDLES HTTP/FIREBASE REQUESTS
// IMPORTANT  --  NO MERGE WITH REDUX LOGIC --

import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';

/**
 * Call the getPayrollExport Firebase function.
 * @param {string} venueId
 * @param {string} startDate  ISO date string e.g. "2026-04-01"
 * @param {string} endDate    ISO date string e.g. "2026-04-30"
 * @returns {Promise<Array>} array of payroll row objects
 */
export const getPayrollExport = async (venueId, startDate, endDate) => {
  try {
    const fn = httpsCallable(functions, 'getPayrollExport');
    const result = await fn({ vid: venueId, startDate, endDate });
    return result.data.rows;
  } catch (error) {
    console.error('Error fetching payroll export:', error);
    throw new Error(`Error fetching payroll export: ${error.message}`);
  }
};

/**
 * Generate a QuickBooks-compatible CSV from payroll rows and trigger download.
 * @param {Array}  rows       payroll row objects returned by getPayrollExport
 * @param {string} startDate  ISO date string
 * @param {string} endDate    ISO date string
 */
export const downloadPayrollCSV = (rows, startDate, endDate) => {
  const header = [
    'Employee Name',
    'Employee ID',
    'Pay Period Start',
    'Pay Period End',
    'Regular Hours',
    'Total Shifts',
    'Tips ($)',
  ].join(',');

  const csvRows = rows.map((row) => {
    const name = `"${(row.displayName ?? '').replace(/"/g, '""')}"`;
    const id = `"${(row.externalId ?? '').replace(/"/g, '""')}"`;
    return [name, id, startDate, endDate, row.regularHours, row.totalShifts, row.tipsOwedDollars].join(',');
  });

  const csv = [header, ...csvRows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `payroll_${startDate}_to_${endDate}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
